import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const usePreferencesStore = defineStore('preferences', () => {
    const soundEnabled = useLocalStorage('pokor_sound', false);
    const confettiEnabled = useLocalStorage('pokor_confetti', true);

    function toggleSound() {
        soundEnabled.value = !soundEnabled.value;
    }

    function toggleConfetti() {
        confettiEnabled.value = !confettiEnabled.value;
    }

    return { soundEnabled, confettiEnabled, toggleSound, toggleConfetti };
});
